export default function HeroSection() {
  return (
    <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Minimalist%20overhead%20flat%20lay%20of%20elegant%20retail%20products%20on%20a%20warm%20oatmeal%20textured%20surface%2C%20featuring%20a%20neatly%20folded%20linen%20shirt%2C%20a%20pair%20of%20minimal%20sneakers%2C%20and%20a%20canvas%20tote%20bag%2C%20soft%20diffused%20morning%20light%20from%20large%20window%2C%20airy%20and%20fresh%20composition%2C%20plenty%20of%20negative%20space%2C%20no%20logos%2C%20no%20text%2C%20editorial%20product%20photography%20with%20clean%20scandinavian%20aesthetic&width=1600&height=1000&seq=hero-v3-main&orientation=landscape"
          alt="AllChinaBuySpreadsheet Sourcing Background"
          className="w-full h-full object-cover"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/18 to-black/35"></div>
      </div>

      <div className="relative z-10 w-full px-6 md:px-10 max-w-4xl mx-auto text-center py-32">
        <p className="inline-block px-4 py-1.5 bg-background-50/20 backdrop-blur-sm border border-background-50/30 rounded-full text-sm font-medium text-background-50 mb-8 whitespace-nowrap">
          Updated Weekly · 2,000+ Products Tracked
        </p>

        <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-background-50 leading-tight mb-6">
          AllChinaBuySheet
          <br />
          <span className="text-background-50/90">The Ultimate China Sourcing Hub</span>
        </h1>

        <p className="text-base md:text-lg text-background-50/80 max-w-2xl mx-auto mb-10 leading-relaxed">
          Discover verified AllChinaBuySpreadsheet lists, winning products, and sourcing strategies
          used by ecommerce sellers worldwide to find profitable inventory faster.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-50 dark:text-foreground-950 rounded-full text-base font-semibold hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            Get Updated Spreadsheet
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 bg-background-50/15 backdrop-blur-sm border border-background-50/40 text-background-50 rounded-full text-base font-semibold hover:bg-background-50/25 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            Explore Product Guides
          </a>
        </div>

        <div className="mt-16 flex items-center justify-center gap-8 md:gap-12">
          <div className="text-center">
            <p className="font-heading text-3xl md:text-4xl font-bold text-background-50">2,000+</p>
            <p className="text-xs md:text-sm text-background-50/70 mt-1">Products Tracked</p>
          </div>
          <div className="w-px h-10 bg-background-50/20"></div>
          <div className="text-center">
            <p className="font-heading text-3xl md:text-4xl font-bold text-background-50">30+</p>
            <p className="text-xs md:text-sm text-background-50/70 mt-1">Categories Updated</p>
          </div>
          <div className="w-px h-10 bg-background-50/20"></div>
          <div className="text-center">
            <p className="font-heading text-3xl md:text-4xl font-bold text-background-50">Weekly</p>
            <p className="text-xs md:text-sm text-background-50/70 mt-1">Verified Updates</p>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-line text-background-50/60 text-2xl"></i>
      </div>
    </section>
  );
}